export default "https://cdn-web.disco.co/slack-validate-connection-dfeb9da46a1b237bd2d0536a8e524ebb.png";